import { parseAsStringLiteral, useQueryState } from 'nuqs';
import { Navigate } from 'react-router';

import { RoutePathType } from '~/routing/enums';
import { useRouting } from '~/routing/useRouting';

import {
  DEFAULT_SETTINGS_SECTION,
  SETTINGS_SECTION_SEARCH_PARAM,
  WORKFLOW_SETTINGS_SEARCH_PARAM,
  workflowUtilityPanelKeys,
} from './workflowSettingsConstants';

const parseAsLegacySection = parseAsStringLiteral(workflowUtilityPanelKeys);

/**
 * Workflow settings moved from a full page into the builder side panel. Keeps
 * links to the retired `/settings` route (and its `section` param) working.
 */
export const WorkflowSettingsRedirect = () => {
  const { params } = useRouting();
  const { workflowId = '' } = params;
  const [section] = useQueryState(
    SETTINGS_SECTION_SEARCH_PARAM,
    parseAsLegacySection,
  );
  const panelSection = section ?? DEFAULT_SETTINGS_SECTION;
  const workflowPath = `${RoutePathType.WorkflowCLMEvolutionWorkflowsDetail.replace(
    ':workflowId',
    workflowId,
  )}/workflow`;

  return (
    <Navigate
      replace
      to={`${workflowPath}?${WORKFLOW_SETTINGS_SEARCH_PARAM}=${panelSection}`}
    />
  );
};
